import React, { useContext, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { useQuery, useLazyQuery } from "@apollo/client";

import { UserContext } from "../reuseableComponents/auth/UserContext";
import { GET_APP_MENU } from "../../queries/menuQrys/baseWLMenuQrys";
import { GET_LSL_REPORT } from "../../queries/ddwAdminQrys/SysAdminReportQrys";
import HeaderBox from "../reuseableComponents/headerBox/HeaderBox";
import ErrorMessage from "../reuseableComponents/ErrorHandler";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import MenuCard from "../reuseableComponents/MenuCard";
import { faSearch, faCloudUploadAlt, faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const menuIcons = {
  DDW_FILE_UPLOAD: faCloudUploadAlt,
  DDW_FU_MGMT: faSearch,
  DDW_FU_ADMIN: faFile
};

const FileUploadIndex = () => {
  const { user } = useContext(UserContext);
  const [menuItems, setMenuItems] = useState([]);
  const displayLSLReportDownload = user.isSysAdmin? 'block': 'none';
  const { loading, error } = useQuery(GET_APP_MENU, {
    variables: { menu: "FILE_UPLD" },
    onCompleted: (result) => {
      let filteredMenuItems;
      if (user.isPortalUser) {
        filteredMenuItems = result.getAppMenu.filter((menu) => menu.accessPortal === true);
      } else if (user.isStaff) {
        filteredMenuItems = result.getAppMenu.filter((menu) => menu.accessStaff === true);
      } else {
        filteredMenuItems = result.getAppMenu;
      }
      setMenuItems(filteredMenuItems);
    }
  });

  const [getLSLReport] = useLazyQuery(GET_LSL_REPORT);

  async function handleLSLDownload(event) {
    event.preventDefault();
    const lslResults = await getLSLReport(); 
    const lslReportObj = lslResults.data.getLSLExportCsv;
    const csvFileStream = lslReportObj.stream.replace(/\r?\n/g, '\r\n');
    const csvFileName = lslReportObj.filename;
    const csvDownload = document.querySelector('#csvLink');
    csvDownload.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvFileStream);
    csvDownload.target = '_blank';
    csvDownload.download = csvFileName;
    csvDownload.click();
  }

  if (loading || error) {
    return (
      <div className='page-container file-upload-index-container'>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='swr-page'>
              <h3 style={{ color: "#fff" }}>File Upload</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorMessage error={error} /> : ""}</Col>
        </Row>
      </div>
    );
  }
  return (
    <div className='page-container file-upload-index-container'>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='swr-page'>
            <h3 style={{ color: "#fff" }}>File Upload</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        {menuItems.map((module) => (
          <Col md={4} key={module.value}>
            <MenuCard icon={menuIcons[module.value]} module={module.value} route={module.route} name={module.label} />
          </Col>
        ))}
        <Col md={4} key={"SDWISMigrationReport"} style={{display: displayLSLReportDownload}}>
          <Card className='m-3 index-card'>
            <Card.Body className='text-center'>
              <a id={'csvLink'} href={'/'}>
                <button onClick={handleLSLDownload} style={{border: 'none', backgroundColor: 'transparent'}} >
                  <FontAwesomeIcon className='font-icon mb-2' icon={menuIcons.DDW_FU_ADMIN} style={{ color: "#147995", fontSize: "500%" }} />
                  <br />
                  <span style={{ color: "#5fa7be", textDecoration: 'underline' }}>{'SDWIS Migration Report CSV'}</span>
                </button>
              </a>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default FileUploadIndex;
